// Polaroid of the bouquet flies to the bag on theme's cart:updated; confirmation popup hidden via .cb-fly in custom.css
(function () {
  if (!window.fetch || !Element.prototype.animate) return;

  var root = document.documentElement;
  root.classList.add('cb-fly');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var pending = null;
  var tagTimer = null;

  var live = document.createElement('div');
  live.className = 'visually-hidden';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  document.addEventListener('DOMContentLoaded', function () {
    document.body.appendChild(live);
    markBags();
  });

  function isVisible(rect) {
    return rect.width > 0 && rect.bottom > 0 && rect.right > 0 &&
      rect.top < window.innerHeight && rect.left < window.innerWidth;
  }

  // Sticky bar lives inside the product section, so it shares the gallery
  var SCOPES = '.product-item, [data-quick-view-modal], .shopify-section';
  // Add-on thumbnails, size drawings and the zoom dialog are never the bouquet
  var SKIP = '.cb-extras, .cb-look, .cb-pdp-sizes, .cross-sells, .sticky-atc-bar';

  // Largest visible product photo; hidden gallery photo as fallback (no rect = pop in at center)
  function findSource(el) {
    var scope = el.closest(SCOPES) || el.parentElement;
    var imgs = scope.querySelectorAll('img');
    var best = null;
    var bestArea = 0;
    var fallback = null;
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.closest(SKIP)) continue;
      var src = img.currentSrc || img.src;
      if (!src || src.indexOf('data:') === 0) continue;
      if (!fallback) fallback = src;
      var rect = img.getBoundingClientRect();
      var area = rect.width * rect.height;
      if (rect.width >= 80 && isVisible(rect) && area > bestArea) {
        best = { src: src, rect: rect };
        bestArea = area;
      }
    }
    return best || (fallback ? { src: fallback, rect: null } : null);
  }

  function findBag() {
    var icons = document.querySelectorAll('[data-js-cart-icon]');
    for (var i = 0; i < icons.length; i++) {
      if (isVisible(icons[i].getBoundingClientRect())) return icons[i];
    }
    return null;
  }

  // Pink count while the bag has something in it
  function markBags() {
    var icons = document.querySelectorAll('[data-js-cart-icon]');
    for (var i = 0; i < icons.length; i++) {
      var count = icons[i].querySelector('[data-js-cart-count]');
      icons[i].classList.toggle('cb-bag--full', !!count && parseInt(count.textContent, 10) > 0);
    }
  }

  function remember(button) {
    pending = { source: findSource(button), button: button, at: Date.now() };
    if (document.fonts) document.fonts.load('20px "CB Hand"');
  }

  document.addEventListener('click', function (e) {
    var quickAdd = e.target.closest && e.target.closest('[data-quick-shop-trigger="quick-add"]');
    if (quickAdd) remember(quickAdd);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var submitter = e.submitter && e.submitter.closest('[data-add-to-cart]');
    var button = submitter || (form.querySelector && form.querySelector('[data-add-to-cart]'));
    if (button) remember(button);
  }, true);

  // Theme fires cart:updated even after cart:error
  document.addEventListener('cart:error', function () {
    pending = null;
  });

  document.addEventListener('cart:updated', function () {
    // Count is redrawn right after the event
    setTimeout(markBags, 50);
    if (!pending || Date.now() - pending.at > 10000) return;
    var added = pending;
    pending = null;
    confirmButton(added.button);
    live.textContent = '';
    live.textContent = 'Added to bag';
    var bag = findBag();
    if (!added.source || reduceMotion.matches) {
      landed(bag, false);
      return;
    }
    polaroid(added.source, bag);
  });

  function polaroid(source, bag) {
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var width = vw < 720 ? 200 : 230;
    var card = document.createElement('div');
    card.className = 'cb-polaroid';
    card.setAttribute('aria-hidden', 'true');
    card.style.width = width + 'px';
    var img = document.createElement('img');
    img.src = source.src;
    img.alt = '';
    var caption = document.createElement('p');
    caption.textContent = 'in your bag!';
    card.appendChild(img);
    card.appendChild(caption);
    document.body.appendChild(card);

    var height = card.offsetHeight;
    var cx = vw / 2;
    var cy = vh * 0.46;
    card.style.left = cx - width / 2 + 'px';
    card.style.top = cy - height / 2 + 'px';

    var from = source.rect && isVisible(source.rect) ? source.rect : null;
    var start = 'translate(0, 0) scale(0.6) rotate(0)';
    if (from) {
      flash(from);
      var sx = from.left + from.width / 2 - cx;
      var sy = from.top + from.height / 2 - cy;
      start = 'translate(' + sx + 'px, ' + sy + 'px) scale(' + Math.min(from.width / width, 2.2) + ') rotate(0)';
    }

    var end = 'translate(0, -80px) scale(0.85) rotate(-4deg)';
    var mid = end;
    if (bag) {
      var to = bag.getBoundingClientRect();
      var dx = to.left + to.width / 2 - cx;
      var dy = to.top + to.height / 2 - cy;
      mid = 'translate(' + dx * 0.68 + 'px, ' + dy * 0.83 + 'px) scale(0.32) rotate(8deg)';
      end = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.06) rotate(14deg)';
    }

    var hold = 'translate(0, 0) scale(1) rotate(-4deg)';
    var flight = card.animate([
      { transform: start, opacity: 0 },
      { transform: start, opacity: 1, offset: 0.06 },
      { transform: hold, opacity: 1, offset: 0.28 },
      { transform: hold, opacity: 1, offset: 0.58 },
      { transform: mid, opacity: 1, offset: 0.8 },
      { transform: end, opacity: bag ? 0.7 : 0 }
    ], { duration: 1700, easing: 'cubic-bezier(.45, 0, .55, 1)', fill: 'forwards' });

    flight.onfinish = function () {
      card.remove();
      landed(bag, true);
    };
  }

  function flash(rect) {
    var veil = document.createElement('div');
    veil.className = 'cb-polaroid-flash';
    veil.setAttribute('aria-hidden', 'true');
    veil.style.left = rect.left + 'px';
    veil.style.top = rect.top + 'px';
    veil.style.width = rect.width + 'px';
    veil.style.height = rect.height + 'px';
    document.body.appendChild(veil);
    veil.animate([{ opacity: 0 }, { opacity: 0.6, offset: 0.3 }, { opacity: 0 }], { duration: 320, easing: 'ease-out' })
      .onfinish = function () { veil.remove(); };
  }

  function landed(bag, moving) {
    markBags();
    if (!bag) return;
    if (moving) bounce(bag);
    showTag(bag);
  }

  function bounce(bag) {
    bag.animate([
      { transform: 'scale(1) rotate(0)' },
      { transform: 'scale(1.22) rotate(-12deg)', offset: 0.35 },
      { transform: 'scale(0.96) rotate(4deg)', offset: 0.7 },
      { transform: 'scale(1) rotate(0)' }
    ], { duration: 520, easing: 'ease-out' });
  }

  function showTag(bag) {
    var old = document.querySelector('.cb-bag-tag');
    if (old) old.remove();
    clearTimeout(tagTimer);
    var rect = bag.getBoundingClientRect();
    var tag = document.createElement('div');
    tag.className = 'cb-bag-tag';
    tag.setAttribute('aria-hidden', 'true');
    tag.textContent = 'Added';
    tag.style.top = rect.bottom + 6 + 'px';
    tag.style.right = Math.max(8, window.innerWidth - rect.right - 4) + 'px';
    document.body.appendChild(tag);
    tagTimer = setTimeout(function () {
      tag.classList.add('is-leaving');
      setTimeout(function () { tag.remove(); }, 300);
    }, 2500);
  }

  function confirmButton(button) {
    var label = button && button.querySelector('[data-add-to-cart-text]');
    if (!label || button.classList.contains('cb-added')) return;
    var original = label.innerHTML;
    var check = document.createElement('span');
    check.className = 'cb-added-check';
    check.setAttribute('aria-hidden', 'true');
    check.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    button.classList.add('cb-added');
    label.parentNode.insertBefore(check, label);
    label.textContent = 'Added to bag';
    setTimeout(function () {
      button.classList.remove('cb-added');
      check.remove();
      if (label.textContent === 'Added to bag') label.innerHTML = original;
    }, 2400);
  }
})();
